export default  [
    {
      path: '/knowledgeMange/KnowledgeList',
      name: 'knowledgeList',
      hideChildrenInMenu: true,
      hidden: true,
      component: () => import('@/views/knowledgeMange/KnowledgeList'),
      meta: { title: 'menu.knowledgeList', keepAlive: true, permission: ['table'] },
    },
    {
      path: '/knowledgeMange/EBusinessModel',
      name: 'eBusinessModel',
      component: () => import('@/views/knowledgeMange/EBusinessModel'),
      meta: { title: 'menu.eBusinessModel', keepAlive: true, permission: ['form'] },
    },
    {
      path: '/knowledgeMange/CreateKnowledge',
      name: 'createKnowledge',
      hideChildrenInMenu: true,
      hidden: true,
      component: () => import('@/views/knowledgeMange/CreateKnowledge'),
      meta: { title: 'menu.createKnowledge', keepAlive: true, permission: ['form'] },
    },
    {
      path: '/knowledgeMange/KnowledgeDetail',
      name: 'knowledgeDetail',
      hideChildrenInMenu: true,
      hidden: true,
      component: () => import('@/views/knowledgeMange/KnowledgeDetail'),
      meta: { title: 'menu.knowledgeDetail', keepAlive: true, permission: ['form'] },
    }
  ]